export default {"src":"/_next/static/media/nest.988d80b1.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};